
$(document).ready(function () {
    // Tab click
    $('.tab-btn').on('click', function () {
        console.log('test')
        const target = $(this).data('tab');

        // Toggle active tab button
        $('.tab-btn').removeClass('active');
        $(this).addClass('active');

        // Hide all sliders
        $('.ba-slider').removeClass('active').hide();

        // Show selected slider
        const $activeSlider = $('#' + target);
        $activeSlider.addClass('active').show();

        // Recalculate slick layout
        $activeSlider.slick('setPosition');
    });

});

$('.testimonial-slider').slick({
    centerMode: true,
    centerPadding: '0',
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                arrows: false,
                centerMode: true,
                centerPadding: '40px',
                slidesToShow: 3,
                slidesToScroll: 3,
            }
        },
        {
            breakpoint: 480,
            settings: {
                arrows: false,
                centerMode: true,
                centerPadding: '40px',
                slidesToShow: 1,
                slidesToScroll: 1,
            }
        }
    ]
});

$('.insta-grid').slick({
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                arrows: false,
                centerMode: true,
                centerPadding: '40px',
                slidesToShow: 3
            }
        },
        {
            breakpoint: 480,
            settings: {
                arrows: false,
                centerMode: true,
                centerPadding: '40px',
                slidesToShow: 1
            }
        }
    ]
});
// Initialize all sliders FIRST
$('.ba-slider').slick({
    arrows: true,
    dots: false,
    adaptiveHeight: true
});




$('.media-slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    centerMode: true,
    variableWidth: true,
    infinite: true,
    focusOnSelect: false,
    cssEase: 'linear',
    touchMove: true,
    prevArrow: '<button class="slick-prev"> < </button>',
    nextArrow: '<button class="slick-next"> > </button>',

    //         responsive: [                        
    //             {
    //               breakpoint: 576,
    //               settings: {
    //                 centerMode: false,
    //                 variableWidth: false,
    //               }
    //             },
    //         ]
});


var imgs = $('.slider img');
imgs.each(function () {
    var item = $(this).closest('.item');
    item.css({
        'background-image': 'url(' + $(this).attr('src') + ')',
        'background-position': 'center',
        '-webkit-background-size': 'cover',
        'background-size': 'cover',
    });
    $(this).hide();
});

document.addEventListener('DOMContentLoaded', () => {
    const header = document.querySelector('.header');
    const navToggle = document.querySelector('.nav-toggle');
    const nav = document.querySelector('.nav');

    // 1. Header scroll effect
    window.addEventListener('scroll', () => {
        if (window.scrollY > 50) {
            header.classList.add('scrolled');
        } else {
            header.classList.remove('scrolled');
        }
    });

    // 2. Mobile navigation toggle
    navToggle.addEventListener('click', () => {
        nav.classList.toggle('open');
        navToggle.classList.toggle('open');
    });

    // Optional: Close nav when a link is clicked (for better UX)
    const navLinks = document.querySelectorAll('.nav-link');
    navLinks.forEach(link => {
        link.addEventListener('click', () => {
            if (nav.classList.contains('open')) {
                nav.classList.remove('open');
                navToggle.classList.remove('open');
            }
        });
    });
});

document.querySelectorAll('.nav-link').forEach(link => {
  link.addEventListener('click', function (e) {
    e.preventDefault();

    const targetId = this.getAttribute('href');
    const targetSection = document.querySelector(targetId);

    targetSection.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  });
});



document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('section[id]');
  const navLinks = document.querySelectorAll('.nav-link');

  let isClickScrolling = false;

  // Default active
  navLinks[0].classList.add('active');

  // Click handling
  navLinks.forEach(link => {
    link.addEventListener('click', e => {
      e.preventDefault();
      isClickScrolling = true;

      // Remove active from all
      navLinks.forEach(item => item.classList.remove('active'));

      // Activate clicked link
      link.classList.add('active');

      const target = document.querySelector(link.getAttribute('href'));

      window.scrollTo({
        top: target.offsetTop - 80, // header offset if needed
        behavior: 'smooth'
      });

      // Unlock scroll detection after animation
      setTimeout(() => {
        isClickScrolling = false;
      }, 800); // adjust if scroll duration differs
    });
  });

  // Scroll-based active
  window.addEventListener('scroll', () => {
    if (isClickScrolling) return;

    let current = '';

    sections.forEach(section => {
      const sectionTop = section.offsetTop - 100;
      if (scrollY >= sectionTop) {
        current = section.getAttribute('id');
      }
    });

    navLinks.forEach(link => {
      link.classList.remove('active');
      if (link.getAttribute('href') === `#${current}`) {
        link.classList.add('active');
      }
    });
  });
});



